import React from 'react';
import PropTypes from 'prop-types';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var variables = {
  COLORS: {
    RED: '#f44336',
    DANGER: '#f44336',
    GREEN: '#4caf50',
    SUCCESS: '#4caf50',
    YELLOW: '#FFC107',
    WARNING: '#FFC107',
    GRAY: '#eee',
    GREY: '#eee'
  },
  SHADOWS: {
    LARGE: '0px 15px 40px rgba(0,0,0,.1)',
    LARGE_DARK: '0px 15px 40px rgba(0,0,0,.2)',
    MEDIUM: '0 8px 20px rgba(0,0,0,.15)',
    MEDIUM_DARK: '0 6px 20px rgba(0,0,0,.25)',
    SMALL: '0 5px 10px rgba(0,0,0,.06)',
    SMALL_DARK: '0 5px 10px rgba(0,0,0,.15)'
  }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_button__19WXC {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  /* font-weight: 600; */\r\n  transition: background-color .3s ease-out;\r\n  padding: 5px 10px;\r\n  border-style: solid;\r\n}\r\n\r\n/* NORMAL */\r\n.styles_NORMAL__1cifz {\r\n  background: #eee;\r\n  color: #000;\r\n  border-color: #ddd;\r\n}\r\n.styles_NORMAL__1cifz:hover{\r\n  background-color: #ddd;\r\n}\r\n\r\n/* DANGER */\r\n.styles_DANGER__1H4x7 {\r\n  background: #f44336;\r\n  color: #fff;\r\n  border-color: #b5362d;\r\n}\r\n.styles_DANGER__1H4x7:hover {\r\n  background: #e05147;\r\n  color: #fff;\r\n}\r\n\r\n\r\n.styles_SUCCESS__3i1ZZ {\r\n  background-color: #4caf50;\r\n  border-color: green;\r\n  color: #fff;\r\n}\r\n.styles_SUCCESS__3i1ZZ:hover{\r\n  background: #38a73c;\r\n}\r\n\r\n/* WARNING */\r\n.styles_WARNING__2wxtU {\r\n  background-color: #FFC107;\r\n  border-color: #dcaf29;\r\n  color: #fff;\r\n}\r\n.styles_WARNING__2wxtU:hover {\r\n  background: #dcaf29;\r\n}";
var styles = { "button": "styles_button__19WXC", "NORMAL": "styles_NORMAL__1cifz", "DANGER": "styles_DANGER__1H4x7", "SUCCESS": "styles_SUCCESS__3i1ZZ", "WARNING": "styles_WARNING__2wxtU" };
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var TYPE = {
  NORMAL: 'NORMAL',
  DANGER: 'DANGER',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING'
};

var SHADOW = variables.SHADOWS;

var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? 'NORMAL' : _ref$type,
      color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      hoverColor = _ref.hoverColor,
      hoverBackgroundColor = _ref.hoverBackgroundColor,
      round = _ref.round,
      bold = _ref.bold,
      border = _ref.border,
      borderColor = _ref.borderColor,
      shadow = _ref.shadow,
      props = objectWithoutProperties(_ref, ['children', 'type', 'color', 'backgroundColor', 'hoverColor', 'hoverBackgroundColor', 'round', 'bold', 'border', 'borderColor', 'shadow']);
  return React.createElement(
    'div',
    _extends({
      className: classnames(styles.button, styles[type]),
      style: {
        color: color,
        backgroundColor: backgroundColor,
        hoverColor: hoverColor,
        hoverBackgroundColor: hoverBackgroundColor,
        borderRadius: round ? typeof round === 'number' ? round : 50 : null,
        fontWeight: bold ? 600 : 400,
        borderWidth: border ? typeof round === 'number' ? round : 2 : 0,
        borderColor: borderColor,
        boxShadow: shadow
      }
    }, props),
    children
  );
};

Button.type = TYPE;
Button.shadow = SHADOW;

Button.propTypes = {
  children: PropTypes.children,
  type: PropTypes.oneOf(TYPE),
  shadow: PropTypes.oneOf(SHADOW)
};

var css$1 = ".styles_wrap__2wCBo {\r\n  display: block;\r\n  padding: 10px 0;\r\n  user-select: none;\r\n}\r\n\r\n.styles_button__12TTq {\r\n  display: inline-block;\r\n  /* padding: 5px 15px; */\r\n  cursor: pointer;\r\n  position: relative;\r\n  transition: all .3s;\r\n  left: 0;\r\n  /* border-top: 1px solid transparent;\r\n  border-bottom: 1px solid transparent; */\r\n  background: #eee;\r\n  border-radius: 0;\r\n  text-align: center;\r\n  overflow: hidden;\r\n  max-width: 200px;\r\n}\r\n.styles_button__12TTq:last-child {\r\n  border-top-right-radius: 8px;\r\n  border-bottom-right-radius: 8px;\r\n}\r\n\r\n.styles_button__12TTq:first-child {\r\n  border-top-left-radius: 8px;\r\n  border-bottom-left-radius: 8px;\r\n}\r\n\r\n\r\n\r\n.styles_collapse__3f-7G {\r\n  background-color: #fff;\r\n  transition: all .3s, color 0s;\r\n  /* border: 1px solid #efefef; */\r\n  border-radius: 8px;\r\n  color: transparent;\r\n  \r\n}\r\n\r\n.styles_active__3cV6w {\r\n  background-color: #4CAF50;\r\n  /* border: 1px solid #2c9a30;     */\r\n  color: #fff;\r\n  box-shadow: 0 2px 10px rgba(0,0,0,.3);\r\n  z-index: 100;\r\n\r\n}\r\n.styles_collapse__3f-7G.styles_active__3cV6w{\r\n  /* border-radius: 8px; */\r\n}\r\n";
var styles$1 = { "wrap": "styles_wrap__2wCBo", "button": "styles_button__12TTq", "collapse": "styles_collapse__3f-7G", "active": "styles_active__3cV6w" };
styleInject(css$1);

var SelectGroup = function (_React$Component) {
  inherits(SelectGroup, _React$Component);

  function SelectGroup() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, SelectGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = SelectGroup.__proto__ || Object.getPrototypeOf(SelectGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isCollapse: true
    }, _this._onMouseLeave = function () {
      clearInterval(_this.intervalCollapse);
      _this.intervalCollapse = setInterval(function () {
        _this.setState({ isCollapse: true });
      }, 300);
    }, _this._onMouseEnter = function () {
      clearInterval(_this.intervalCollapse);
      _this.setState({ isCollapse: false });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(SelectGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$activeIdx = _props.activeIdx,
          activeIdx = _props$activeIdx === undefined ? 2 : _props$activeIdx,
          _props$align = _props.align,
          align = _props$align === undefined ? 'right' : _props$align,
          _props$onChange = _props.onChange,
          onChange = _props$onChange === undefined ? function () {} : _props$onChange,
          children = _props.children,
          _props$height = _props.height,
          height = _props$height === undefined ? 45 : _props$height;
      var isCollapse = this.state.isCollapse;


      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          {
            onMouseEnter: this._onMouseEnter,
            onMouseLeave: this._onMouseLeave,
            className: styles$1.wrap,
            style: { textAlign: align === 'right' ? 'right' : 'left', display: 'inline-block' }
          },
          children.map(function (button, idx) {
            return React.createElement(
              'div',
              {
                key: idx,
                onClick: function onClick() {
                  onChange(idx);
                },
                className: classnames(styles$1.button, defineProperty({}, styles$1.active, activeIdx === idx), defineProperty({}, styles$1.collapse, isCollapse), 'fozg-ui-SelectGroup', { 'fozg-ui-SelectGroup-active': activeIdx === idx }, { 'fozg-ui-SelectGroup-expand': !isCollapse }),
                style: _extends({}, isCollapse && activeIdx !== idx ? {
                  maxWidth: 30,
                  zIndex: 100 - Math.abs(activeIdx - idx),
                  boxShadow: idx < activeIdx ? '-4px 0 4px rgba(0,0,0,.1)' : '4px 0 4px rgba(0,0,0,.1)'
                } : null, isCollapse ? { left: (align === 'right' ? (children.length - idx - 1) * 15 : idx * 15) + 'px' } : null, {
                  height: height
                })
              },
              button
            );
          })
        )
      );
    }
  }]);
  return SelectGroup;
}(React.Component);

SelectGroup.propTypes = {
  activeIdx: PropTypes.number,
  // isCollapse: PropTypes.bool,
  onChange: PropTypes.func,
  align: PropTypes.bool,
  children: PropTypes.children,
  height: PropTypes.number
};

var css$2 = ".styles_callout__7_ZqG {\r\n  border: 1px solid #ddd;\r\n  border-radius: 3px;\r\n  border-bottom-right-radius: 5px;\r\n  border-top-right-radius: 5px;\r\n  border-left: 4px solid #607D8B;\r\n}\r\n\r\n.styles_SMALL__3COKP {\r\n  padding: 10px;\r\n}\r\n\r\n.styles_NORMAL__b-P4l {\r\n  padding: 20px;\r\n}\r\n\r\n.styles_LARGE__2whX7 {\r\n  padding: 40px;\r\n}";
var styles$2 = { "callout": "styles_callout__7_ZqG", "SMALL": "styles_SMALL__3COKP", "NORMAL": "styles_NORMAL__b-P4l", "LARGE": "styles_LARGE__2whX7" };
styleInject(css$2);

var PADDED = {
  SMALL: 'SMALL',
  NORMAL: 'NORMAL',
  LARGE: 'LARGE'
};

var Callout = function Callout(_ref) {
  var children = _ref.children,
      _ref$padded = _ref.padded,
      padded = _ref$padded === undefined ? 'NORMAL' : _ref$padded,
      props = objectWithoutProperties(_ref, ['children', 'padded']);
  return React.createElement(
    'div',
    _extends({
      className: classnames(styles$2.callout, styles$2[padded])
    }, props),
    children
  );
};

Callout.padded = PADDED;

Callout.propTypes = {
  children: PropTypes.children,
  padded: PropTypes.oneOf(PADDED)
};

var css$3 = ".styles_card__cvT83 {\r\n  display: inline-block;\r\n  box-shadow: 0 10px 20px rgba(0, 0,0, .1);\r\n  position: relative;\r\n  width: 80px;\r\n  height: 80px;\r\n  background-color: #3f51b5;\r\n  overflow: hidden;\r\n  color: #fff;\r\n  transition: transform .3s;\r\n}\r\n.styles_card__cvT83:hover {\r\n  transform: translateY(-20px)\r\n}\r\n\r\n.styles_card__cvT83 .styles_children__1lpQC {\r\n  position: absolute;\r\n  z-index: 10;\r\n  top: 50%;\r\n  left: 0;\r\n  width: 100%;\r\n  text-align: center;\r\n  font-weight: 600;\r\n  transform: translateY(-50%)\r\n}\r\n\r\n.styles_card__cvT83 .styles_blur__2Gug0 {\r\n  position: absolute;\r\n  z-index: 9;\r\n  bottom: -40%;\r\n  left: -50%;\r\n  width: 200%;\r\n  \r\n  height: 100%;\r\n  background: radial-gradient(ellipse at bottom, rgba(0, 0, 0, 0.5) 0%,rgba(0, 0, 0, 0) 60%)\r\n}\r\n\r\n.styles_card__cvT83 .styles_top__34k_s {\r\n  position: absolute;\r\n  z-index: 9;\r\n  top: -30%;\r\n  left: -50%;\r\n  width: 200%;\r\n  \r\n  height: 100%;\r\n  background: radial-gradient(ellipse at top, rgba(255, 255, 255, 0.5) 0%,rgba(255, 255, 255, 0) 60%)\r\n}";
var styles$3 = { "card": "styles_card__cvT83", "children": "styles_children__1lpQC", "blur": "styles_blur__2Gug0", "top": "styles_top__34k_s" };
styleInject(css$3);

var Card = function Card(_ref) {
  var children = _ref.children,
      _ref$borderd = _ref.borderd,
      borderd = _ref$borderd === undefined ? true : _ref$borderd,
      style = _ref.style;
  return React.createElement(
    'div',
    {
      className: styles$3.card,
      style: _extends({
        borderRadius: borderd ? 8 : 0,
        padding: 10,
        boxShadow: variables.SHADOWS.LARGE_DARK
      }, style)
    },
    React.createElement('div', { className: styles$3.top }),
    React.createElement('div', { className: styles$3.blur }),
    React.createElement(
      'div',
      { className: styles$3.children },
      children
    )
  );
};

Card.propTypes = {
  children: PropTypes.children,
  borderd: PropTypes.bool,
  style: PropTypes.object
};

var css$4 = "h1 {\r\n  font-weight: 400;\r\n  margin: 0\r\n}\r\n\r\n\r\nh2 {\r\n  font-weight: 400;\r\n  margin: 0\r\n}\r\n";
var styles$4 = {};
styleInject(css$4);

/**
 * H1
 * @param {React} children
 */
var H1 = function H1(_ref) {
  var children = _ref.children;
  return React.createElement(
    'h1',
    { className: styles$4.h1 },
    children
  );
};

H1.propTypes = {
  children: PropTypes.children

  /**
   * H2
   * @param {React} children
   */
};var H2 = function H2(_ref2) {
  var children = _ref2.children;
  return React.createElement(
    'h1',
    { className: styles$4.h2 },
    children
  );
};

H2.propTypes = {
  children: PropTypes.children
};

export { Button, SelectGroup, Callout, H1, Card, H2 };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/fozg-ui/dist/index.es.js
// module id = 19
// module chunks = 0